import {FormattedDialogTitle} from "@dvrt/graphql-widgets";
import {Dialog, DialogContent} from "@mui/material";
import {FC} from "react";
import {defineMessage} from "react-intl";
import MediaPlayer from "./MediaPlayer";

const title = defineMessage({
    id: "media_player_dialog.title",
    defaultMessage: "Media Player",
});

type DialogMediaPlayerProps = {
    open: boolean;
    onClose: () => void;
    mediaDownloadToken: string;
};

const DialogMediaPlayer: FC<DialogMediaPlayerProps> = ({open, onClose, mediaDownloadToken}) => {
    return (
        <Dialog open={open}>
            <FormattedDialogTitle title={title} closingButton onClose={onClose} />
            <DialogContent>
                <MediaPlayer token={mediaDownloadToken} />
            </DialogContent>
        </Dialog>
    );
};

export default DialogMediaPlayer;
